import { SUB_AGENT_CONFIGS } from "@/shared/sub-agents";

export function SubAgentRoster() {
  return (
    <div className="rounded-xl border bg-card p-4 space-y-3">
      <h4 className="font-medium text-sm">Sub-Agents + Hard-Coded Models</h4>
      <div className="space-y-2">
        {SUB_AGENT_CONFIGS.map((agent) => (
          <div key={agent.id} className="rounded-lg border p-2">
            <div className="flex items-center justify-between gap-2">
              <p className="text-sm font-medium">{agent.name}</p>
              <span
                className={`text-[10px] px-2 py-0.5 rounded-full border ${
                  agent.enabled
                    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                    : "bg-muted text-muted-foreground border-border"
                }`}
              >
                {agent.enabled ? "Enabled" : "Disabled"}
              </span>
            </div>
            <p className="text-xs text-muted-foreground">{agent.description}</p>
            <p className="text-xs mt-1">
              <span className="font-medium">Model:</span> {agent.modelId}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
